import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=68e1a5de&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=68e1a5de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e1a5de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68e1a5de')) {
      api.createRecord('68e1a5de', component.options)
    } else {
      api.reload('68e1a5de', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=68e1a5de&scoped=true&", function () {
      api.rerender('68e1a5de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TJEiIG3Bw3ol/JS/comp/PopupDialog.vue"
export default component.exports